module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAQCAYAAAAWGF8bAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAEESURBVDiNnZM9TsNAEEbf+EdKmSOEG/gISes0IGFajAU9R4AbhJ5gp8UUKQJtcoQcgSOkjBTDUBChYO/Ka79uP888fV5p4YQ4ydLpZXZPDVtuIjg9CJIjAMxcchMSJ3eRiF6jOgTSY17U5v7lytfTR1lsjQ2F7xwlsgjqpL+N/TFwZhrwoCFzYWT7ECDWNr0IUMY9dxdmof2+2rgxhZ7LpsAS2LnMtgpF5HFVzi8QKToLBZaiMgE+/2Svzw9xkqWodn8pClFYVdv9gIlfeeercj6LkywVJHeRNRoCo0Porwd7du9vL51ljYZHokPor6dXtxvX32wTAkSo9nlBeMCmx5515wdboEewMbEqYwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/yy9.png
// module id = edCf
// module chunks = 1